import { ArrivalReportRequestModel } from '../api/models/ArrivalReportRequestModel';
import { ArrivalReportFormModel } from '../models';

export const dataFormToRequest = (data: ArrivalReportFormModel): ArrivalReportRequestModel => ({
  from: data.from,
  to: data.to,
  card_ids: data.card_ids.map(card => card.id),
  rate_ids: data.rate_ids,
  room_type_ids: data.room_type_ids,
  states: data.states,
  price: data.price,
  nationality_ids: (data.nationality_ids || [])?.map(item => Number(item.id)),
  file_type: data?.file_type,
  sort_by: data.sortBy,
  direction: data.sortDirection,
  ...(data.grouped ? { group_by: 'market_agency' } : {}),
  exclude_partial: data.exclude_partial,
});
